import { render, staticRenderFns } from "./inboundReport.vue?vue&type=template&id=4ab29345&scoped=true"
import script from "./inboundReport.vue?vue&type=script&lang=js"
export * from "./inboundReport.vue?vue&type=script&lang=js"
import style0 from "./inboundReport.vue?vue&type=style&index=0&id=4ab29345&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab29345",
  null
  
)

export default component.exports